module.exports = __webpack_public_path__ + "5362adf0d78c05ad50f669ce1d1cf0fa.jpg";